export default __webpack_public_path__ + "static/media/FOREST FIRES.13b5c6c8.jpg";